import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type UserModel from './user';

export default class ProductGroupModel extends Model {
  declare [Type]: 'product-group';
  @attr()
  declare name: string;
  @attr()
  declare active: boolean;
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;
  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare updated_by: UserModel;
}
